export default {
    shuffle(array) {
        var currentIndex = array.length,
            temporaryValue,
            randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    },

    random(array) {
        return array[Math.floor(Math.random() * array.length)];
    },

    remove(array, element) {
        let index = array.indexOf(element);

        if (index != -1) {
            array.splice(index, 1);
            return true;
        }

        return false;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = 55
// module chunks = 0